// MobileSidebarButton.jsx
import React from 'react';
import { FaBars } from 'react-icons/fa';
import { motion } from 'framer-motion';


const MobileSidebarButton = ({ onClick, isVisible }) => {
  return (
    <motion.div 
      className="mobile-sidebar-toggle"
      onClick={onClick}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ 
        opacity: isVisible ? 1 : 0,
        scale: isVisible ? 1 : 0.8,
        pointerEvents: isVisible ? 'auto' : 'none'
      }}
      transition={{ duration: 0.3 }}
    >
      <FaBars />
    </motion.div>
  );
};

export default MobileSidebarButton;